import React, { useRef } from 'react'
import { generateRandomKey } from '@utils'
import { StyledDiv, FootnoteContainer } from '../style'
import ReactMarkdown from 'react-markdown'

const ArticleFootnote = ({ content }) => {
  const mappedVals = content?.references?.filter(
    c => c.__typename === 'ContentfulFootnote'
  )
  const ref = useRef()
  const handleRef = id => {
    if (document !== undefined && window !== undefined) {
      ref.current = document.getElementById(id)
      // get the actual height of the navigation bar
      const navElement = document.getElementById('navigation')
      const navbarOffset = navElement.offsetHeight
      window.scrollTo({
        top: ref.current.offsetTop + navbarOffset + 35, // adding a little extra space
      })
    }
    return null
  }

  return (
    <>
      <span
        id="footnote"
        style={{
          display: 'block',
          height: '115px',
          marginTop: '-115px',
          visibility: 'hidden',
          pointerEvents: 'none',
        }}
      ></span>
      {mappedVals?.length > 0 && <hr />}
      {mappedVals?.map((f, i) => {
        return (
          <FootnoteContainer
            key={generateRandomKey()}
            style={{ display: 'flex' }}
          >
            <StyledDiv
              fontSize={18}
              data-testid="footnote"
              onClick={() => handleRef(f.id)}
            >{`[${i + 1}]`}</StyledDiv>
            <ReactMarkdown>{f?.footnoteBody?.footnoteBody}</ReactMarkdown>
          </FootnoteContainer>
        )
      })}
    </>
  )
}

export default ArticleFootnote
